<template>
  <ui-container>
    <ui-row
      align-h="center"
      class="book-page"
      :class="{ 'book-page-with-cover': book.cover }"
      v-if="book"
    >
      <ui-col col="10">
        <ui-loader
          :loading="loading"
          :lang="loaderLang"
          :completed="completed"
          :listens="['pull-down', 'pull-up']"
          @pull-down="pullDown"
          :show-footer="false"
        >
          <ui-card v-if="book">
            <ui-image
              class="book-cover"
              :src="book.cover[0]"
              v-if="book.cover.length < 2"
            >
            </ui-image>
            <ui-carousel
              @change="coverChange"
              nav-style="arrow"
              full-width
              loop
              :delay="3000"
              v-if="book.cover.length >= 2"
            >
              <ui-image
                :key="img"
                v-for="img of book.cover"
                :src="img"
                cover
              ></ui-image>
            </ui-carousel>
            <ui-avatar
              class="book-author-avatar"
              :url="book.userInfo.avatar"
              :username="book.userInfo.username"
              size="lg"
              >{{ $d(new Date(book.created), "long") }}
              <span class="muted">-</span>
              <span
                ><ui-icon name="icon-team" :title="$t('views')"></ui-icon>
                {{ book.pv }}</span
              ><span class="muted">-</span>
              <Favorite :book="book"></Favorite>
            </ui-avatar>
            <book-actions
              :book="book"
              :link="link"
              :cover-index="coverIndex"
            ></book-actions>
            <ui-heading tag="h3" bold margin class="book-title">
              {{ book.title }}
            </ui-heading>
            <div class="book-intro" v-if="book.intro">{{ book.intro }}</div>
            <book-link :book="book"></book-link>
            <template v-if="!book.requireAuth">
              <ui-button
                type="primary"
                full
                v-if="book.allowCoWrite"
                @click.native="addArticle"
              >
                <ui-icon name="plus"></ui-icon>{{ $t("addNewArticle") }}
              </ui-button>
              <ui-button
                type="primary"
                full
                disabled
                v-if="!book.allowCoWrite"
                >{{ $t("submitClosed") }}</ui-button
              >
              <article-list from="book" :book-id="book.id"></article-list>
            </template>
            <div v-if="book.requireAuth">
              <ui-hr>{{ $t("typeBookPasswordHere") }}</ui-hr>
              <password-input :book="book"></password-input>
            </div>
          </ui-card>
        </ui-loader>
      </ui-col>
      <div v-if="!book.requireAuth" class="bottom-button"></div>
    </ui-row>
  </ui-container>
</template>
<script>
import api from "../api/index";
// import BookMeta from "../components/book/BookMeta.vue";
// import Password from "../components/Password.vue";
// import BookMenu from "../components/book/BookMenu.vue";
import BookLink from "../components/book/BookLink.vue";
import BookActions from "../components/book/BookActions.vue";
import ArticleList from "../components/article/ArticleList.vue";
import PasswordInput from "../components/Password.vue";
import Favorite from "../components/Favorite.vue";
// import ArticleCreate from "../components/article/ArticleCreate.vue";
import { mapGetters } from "vuex";
import config from "../config.js";
import { browserTitle } from "../utils/utils.js";
export default {
  data() {
    return {
      showLoader: true,
      articleList: [],
      editorKey: Date.now(),
      book: null,
      loaderLang: {
        pullDownToRefresh: this.$t("pullDownToRefresh"),
        releaseToRefresh: this.$t("releaseToRefresh"),
        pullUpToLoad: this.$t("pullUpToLoad"),
        loadCompleted: " " //loadCompleted
      },
      loading: false,
      completed: false,
      coverIndex: 0
    };
  },
  components: {
    // BookMeta,
    // Password,
    // BookMenu,
    BookLink,
    BookActions,
    ArticleList,
    PasswordInput,
    Favorite
    // ArticleCreate
  },
  computed: {
    ...mapGetters(["authInfo"]),
    query() {
      if (this.book) {
        return {
          type: "book",
          from: this.book.id
        };
      } else {
        return "";
      }
    },
    link() {
      return `${this.host}${this.book.code}`;
    },
    host() {
      return `${config[process.env.NODE_ENV].fullHost}/@${
        this.book.userInfo.username
      }/`;
    }
  },
  mounted() {
    this.loadBook();
  },
  methods: {
    coverChange(index) {
      this.coverIndex = index;
    },
    pullDown() {
      this.book = null;
      this.loadBook();
    },
    addArticle() {
      this.$router.push(
        `/@${this.book.userInfo.username}/${this.book.code}/addArticle`
      );
    },
    handleLink(link) {
      this.book.link = link.code;
    },
    handleRemoveLink() {
      this.book.link = "";
    },
    loadBook() {
      this.loading = true;
      let id = this.$route.params.id;
      let code = this.$route.params.code;
      let username = this.$route.params.username;
      let query = { id, code, username };
      api
        .getBookByCode({
          username: username,
          code: code
        })
        .then(res => {
          this.loading = false;
          this.completed = true;
          this.book = res.data.content;
          browserTitle(this.book.title + " - " + this.book.userInfo.username);
        })
        .catch(err => {
          console.log(err);
          // this.$router.push("/404");
        });
    }
  }
};
</script>
